import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { clsx } from 'clsx';
import { useRealmAuthContext } from '@interxfi/api-client';
import { useRealmAuthIsAuthenticated } from '@interxfi/api-client/context';
import { EmptyIllustration } from '@interxfi/design-system/components/illustration/empty-illustration';
import QuestionMarkIcon from '@interxfi/design-system/icons/react/icon-questionmark';
import { MFA_SETUP_ROUTE } from '../../util/routing/defaults';
import { Layout } from '../layout/layout';
import styles from './not-found.module.scss';

export function NotFound() {
  const navigate = useNavigate();
  const isAuthenticated = useRealmAuthIsAuthenticated();
  const context = useRealmAuthContext();
  const illustration = (
    <EmptyIllustration
      icon={<QuestionMarkIcon aria-hidden />}
      message="Page Not Found"
      subMessage="Sorry, the page you're looking for doesn't exist or has been moved."
    />
  );

  const hasOrganizationMembershipThatRequiresMfa = Boolean(
    context?.organizationMemberships?.some((org) => org.organization?.data?.controls?.settings?.requireMfa),
  );
  const hasMfaConfigured = Boolean(context?.hasMFA);

  useEffect(() => {
    if (hasOrganizationMembershipThatRequiresMfa && !hasMfaConfigured) {
      void navigate({ to: MFA_SETUP_ROUTE });
    }
  }, [navigate, hasOrganizationMembershipThatRequiresMfa, hasMfaConfigured]);

  return (
    <div className={clsx(styles.notFound, !isAuthenticated && styles.unauthenticated)}>
      {isAuthenticated ? <Layout>{illustration}</Layout> : illustration}
    </div>
  );
}
